module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-full-3bd5d686702f5cdd2a0c2f9e6314fa36.svg";